
import { Injectable } from '@angular/core';
import { GridSettings } from './grid-settings-service';

const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (_key: any, value: any) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};

@Injectable()
export class StatePersistingService {
    
    public get<T>(token: string): T | null;
    public get<T>(token: string, defaultValue: T): T;

    public get<T>(token: string, defaultValue?: T): T | null {
        const settings = localStorage.getItem(token);

        if (settings !== null) {
        return JSON.parse(settings) as T;
        }

        return defaultValue ?? null;
    }

    public set<T>(token: string, gridConfig: GridSettings): void {
        localStorage.setItem(token, JSON.stringify(gridConfig, getCircularReplacer()));
    }
}